import * as React from 'react'
import { ReactElement } from 'react'
import { FormikContextType } from 'formik'
import DateRange from '../../DateRange/LegacyDateRange'

type Props = {
    context: FormikContextType<any>
    startName: string
    endName: string
    showLabel?: boolean
}

export default function FormikDateRange(props: Props): ReactElement {
    const { values, setFieldValue } = props.context
    return (
        <DateRange
            startValue={values[props.startName]}
            endValue={values[props.endName]}
            changeStartDate={date => setFieldValue(props.startName, date)}
            changeEndDate={date => setFieldValue(props.endName, date)}
            showLabel={props.showLabel || true}
        />
    )
}
